import { KeyValueMappingProps } from "@hightouch/formkit";
import { SharedProps } from ".";
import { Controller } from "react-hook-form";
import { KeyValueMapping } from "src/components/destinations/key-value-mapping";

export const FKKeyValueMapping = ({
  name,
  enableEncryption,
  isDisabled,
}: KeyValueMappingProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <KeyValueMapping
        isDisabled={isDisabled}
        enableEncryption={enableEncryption}
        mapping={field.value}
        setMapping={field.onChange}
      />
    )}
  />
);
